import api, { ApiResponse } from './api';

import { Plan } from 'entities/Plan';

interface GetPlanListResponse {
  success: boolean;
  data: Plan[];
}

export const getPlanListService = (): ApiResponse<GetPlanListResponse> =>
  api({
    method: 'GET',
    url: 'plans',
    useToken: true,
  });
